import ApiService from '@/common/api/api.service';

let apiBasePath = 'HistoricoEscolar';
const HistoricoEscolarService = {
  async imprimir(params) {
    let { data } = await ApiService.post(
      `${apiBasePath}/imprimir-historico`,
      null,
      {
        params: { ...params },
      }
    );
    return data;
  },

  async imprimirHistoricoEmLote(form) {
    let { data } = await ApiService.post( 
      `${apiBasePath}/imprimir-historico-em-lote`,
      form,
    );

    return data;
  },
};

export default HistoricoEscolarService;
